'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';

export const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #F5F5F5;
`;

export const OverlayContent = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 20;
`;

export const LeftButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BadgeButton = styled.button`
  background: ${COLORS.white};
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  white-space: nowrap;
`;

export const BadgeText = styled.div<{ color?: string }>`
  font-size: 12px;
  line-height: 1;
  font-weight: 500;
  color: ${props => props.color || 'inherit'};
`;

export const SwiperBox = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .custom-prev,
  .custom-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    border-radius: 4px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    z-index: 10;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #151b2850 !important;
    color: white;
    font-size: 24px;
    transition: background 0.2s ease;

    &:hover {
      background: #151b2870 !important;
    }

    &.swiper-button-disabled {
      display: none;
    }
  }

  .custom-prev span,
  .custom-next span {
    display: block;
    width: fit-content;
  }

  .custom-prev {
    left: 8px;
  }

  .custom-next {
    right: 8px;
  }

  .custom-pagination {
    position: absolute;
    bottom: 8px;
    align-items: center;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
    z-index: 10;
    padding: 4px 6px;
    background: #151b2850 !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .custom-pagination .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background: white;
    opacity: 0.6;
    border-radius: 50%;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .custom-pagination .swiper-pagination-bullet-active {
    opacity: 1;
    background: white;
    transform: scale(1.1);
  }
`;
